import { NotifyHelper } from "../../../helpers/toast";
import { objNguonBietToiDefine } from "../../action-types/crm-category/IDmNguonBietToiActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const nguonBietToiActions = {
    ...generateActions(objNguonBietToiDefine, "NGUON_BIET_TOI"),
    ...generateActionForKey(objNguonBietToiDefine, "NGUON_BIET_TOI",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNguonBietToiDefine, "NGUON_BIET_TOI",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objNguonBietToiDefine, "NGUON_BIET_TOI",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNguonBietToiDefine, "NGUON_BIET_TOI",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objNguonBietToiDefine, "NGUON_BIET_TOI",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
